import DateFnsUtils from '@date-io/date-fns';
import {Trans} from '@lingui/macro';
import {Button, Divider, LinearProgress, MenuItem} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {Title} from 'components/forms';
import useRole from 'components/GenericsHooks/useRoles';
import CustomAlert from 'components/grid-dx/alert';
import {course} from 'constants/url';
import {CourseSchema} from 'features/course/modal/Course';
import {i18n2} from 'features/i18n/i18n';
import {FastField, Field, Form, Formik} from 'formik';
import {TextField} from 'formik-material-ui';
import {KeyboardDatePicker} from 'formik-material-ui-pickers';
import authFetch from 'helpers/requests';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect} from 'react-router-dom';
import getCourseType from '../hooks/getCourseType';
import CheckboxWithLabel from './CustomCheckBox';
import {CapaIniAlert} from './CapaIniAlert';

const CreateCoursePopup = ({open, setOpen, handleClose, refresh}) => {
  const role = useRole();
  // const loadCourseType = useLoadCourseType(role);
  const user = useSelector((state) => state.authentication.user.name);
  const token = useSelector((state) => state.authentication.user.token);
  const dispatch = useDispatch();
  const [type, setType] = useState([]);
  const [id, setId] = useState();
  const [message, setMessage] = useState({
    text: '',
    open: false,
    successful: false,
  });
  const [redirect, setRedirect] = useState(false);
  const [typeCourse, setTypeCourse] = useState('');
  let timeout;

  useEffect(() => {
    getCourseType(role, token)
      .then((data) => {
        if (typeof data !== undefined) {
          setType(data);
        }
      })
      .catch(() => {});
  }, [role, token]);

  const submit = async (values) => {
    const method = 'POST';
    setTypeCourse(values.iD_Type);
    let info = {...values, user: user, rol: role};
    if (info.dateVig === null) {
      info.dateVig = '';
    }
    info = JSON.stringify(JSON.stringify(info));
    try {
      const response = await authFetch(
        `${course}`,
        {
          method: method,
          headers: {
            'Content-Type': 'application/json',
          },
          body: info,
        },
        token,
      );
      if (response.ok) {
        response.json().then((data) => {
          dispatch({type: 'SAVE_ID_COURSE', payload: data});
          setId(data);
        });
        setMessage({
          text: i18n2._('Curso creado correctamente'),
          open: true,
          successful: true,
        });
        refresh();
        // eslint-disable-next-line no-unused-vars
        timeout = setTimeout(() => setRedirect(true), 1000);
      } else {
        response
          .text()
          .then((message) =>
            setMessage({text: message, open: true, successful: false}),
          );
        setMessage({text: response.message, open: true});
      }
    } catch (error) {
      return console.log(error);
    }
  };

  if (redirect) {
    return (
      <Redirect
        to={{
          pathname: '/Course',
          type: 'edit',
          state: {id: id, type: false, typeCourse: typeCourse},
        }}
      />
    );
  } else {
    return (
      <>
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
          scroll="body"
          maxWidth="md"
          fullWidth={true}
          onClose={() => handleClose()}>
          <Title onClose={handleClose} title={i18n2._('Crear curso')} />
          <Divider />
          <DialogContent>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Formik
                initialValues={{
                  doc_Number: '',
                  iD_Type: '',
                  company: 'Mox It SRL',
                  name: '',
                  score: '100',
                  version: '1',
                  dateVig: null,
                  content: '',
                  reason: '',
                  pass: '',
                  user: user,
                  included_capa_ini: false,
                }}
                onSubmit={submit}
                validationSchema={CourseSchema(true, true)}>
                {(formikProps) => {
                  return (
                    <Form>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <CapaIniAlert formikProps={formikProps} />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Field
                            name="name"
                            required
                            component={TextField}
                            label={i18n2._('Nombre')}
                            fullWidth
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <Field
                            name="version"
                            component={TextField}
                            required
                            label={i18n2._('Versión')}
                            fullWidth
                            variant="outlined"
                            disabled
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <Field
                            name="doc_Number"
                            required
                            component={TextField}
                            label={i18n2._('Documento/Código')}
                            autoFocus
                            fullWidth
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <Field
                            name="iD_Type"
                            component={TextField}
                            select
                            required
                            label={i18n2._('Tipo')}
                            fullWidth
                            variant="outlined">
                            {type.map((value) => {
                              return (
                                !value.Deleted && (
                                  <MenuItem
                                    key={value.iD_Type}
                                    value={value.iD_Type}>
                                    {value.name}
                                  </MenuItem>
                                )
                              );
                            })}
                          </Field>
                        </Grid>
                        <Grid item xs={5}>
                          <Field
                            name="company"
                            required
                            component={TextField}
                            label={i18n2._('Compañía')}
                            fullWidth
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <Field
                            name="score"
                            required
                            component={TextField}
                            label={i18n2._('Puntaje mínimo')}
                            fullWidth
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            name="content"
                            component={TextField}
                            label={i18n2._('Descripción')}
                            fullWidth
                            variant="outlined"
                            multiline
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            name="dateVig"
                            component={KeyboardDatePicker}
                            label={i18n2._('Fecha de vigencia')}
                            fullWidth
                            inputVariant="outlined"
                            disableToolbar
                            variant="inline"
                            views={['year', 'month', 'date']}
                            format="dd/MM/yyyy"
                            // disablePast
                            required
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            name="included_capa_ini"
                            type="checkbox"
                            component={CheckboxWithLabel}
                            Label={{
                              label: i18n2._('Incluir en capacitacion inicial'),
                            }}
                            formikProps={formikProps}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            label={i18n2._('Reason')}
                            name={'reason'}
                            fullWidth
                            variant="outlined"
                            component={TextField}
                            validate={(value) => {
                              let error;
                              if (
                                typeof value !== 'undefined' &&
                                value.length === 0
                              ) {
                                error = i18n2._('Please provide a reason');
                              }
                              return error;
                            }}
                            multiline
                          />
                        </Grid>
                        <Grid item sm={6} xs={12} style={{padding: 20}}>
                          <Field
                            label={i18n2._('User')}
                            name={'user'}
                            variant="standard"
                            size="small"
                            fullWidth
                            component={TextField}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            disabled={true}
                          />
                        </Grid>
                        <Grid item sm={6} xs={12} style={{padding: 20}}>
                          <FastField
                            label={i18n2._('Password')}
                            name={'pass'}
                            variant="standard"
                            size="small"
                            fullWidth
                            component={TextField}
                            type="password"
                            validate={(value) => {
                              let error;
                              if (
                                typeof value !== 'undefined' &&
                                value.length === 0
                              ) {
                                error = i18n2._('Please provide a password');
                              }
                              return error;
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        {formikProps.isSubmitting && <LinearProgress />}
                        <Grid item xs={12}>
                          <div style={{float: 'right', marginBottom: '10px'}}>
                            <Button
                              onClick={() => handleClose()}
                              className="red-text">
                              {i18n2._('Cancelar')}
                            </Button>
                            <Button
                              type="submit"
                              disabled={formikProps.isSubmitting}
                              variant="contained"
                              color="primary">
                              <Trans>Crear</Trans>
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </Form>
                  );
                }}
              </Formik>
            </MuiPickersUtilsProvider>
          </DialogContent>
          <CustomAlert
            message={message.text}
            ms={1000}
            successful={message.successful}
            handleClose={() => setMessage((prev) => ({...prev, open: false}))}
            open={message.open}
          />
        </Dialog>
      </>
    );
  }
};

export default CreateCoursePopup;
